import React from "react"
import { connect, useDispatch, useSelector } from "react-redux"
import PropTypes from "prop-types"
import useLangSwitch from "components/hooks/useLanguageSwicth"
import usePrice from "components/hooks/usePrice"
import { Link } from "react-router-dom"
import { FaHeart, FaRegHeart } from "react-icons/fa"
import { defualtProd } from "assets/imgs/logos"
import useWishlistAction from "components/hooks/useWishlistAction"
import useCloudinary from "components/hooks/useCloudinaryImage"
import { TbTruckDelivery } from "react-icons/tb"
import LazyLoad from "react-lazyload"

const ProductCardTwo = ({ product }) => {
  const dispatch = useDispatch()

  const { freeShippingThreshold } = useSelector(state => ({
    freeShippingThreshold:
      state.SiteSettings.siteSettings.shipping?.freeShippingThreshold,
  }))

  const user_favourite =
    storage.get("user_favourite") !== null && storage.get("user_favourite")

  const handleWishlist = productId => {
    useWishlistAction(dispatch, productId)
  }

  const language = useLangSwitch(product?.primaryLang, product?.secondaryLang)

  const { currencyCode, oldPrice, price, currentVarient } = usePrice(product)

  const diff = Math.abs(oldPrice - price)

  const discountPercentage =
    (oldPrice ?? 0) > price ? Math.floor((diff / oldPrice) * 100) : ""

  return (
    <>
      <div className="product-cart-wrap border-none">
        <div className="product-img-action-wrap">
          <div className="product-img product-img-zoom m-auto ">
            <Link
              to={`/products/${useRemoveSpace(product?.primaryLang?.name)}`}
            >
              <img
                className="default-img"
                src={`${
                  useCloudinary(product.images[0]?.url, "w_500") ?? defualtProd
                }`}
                alt="Idealsply-product"
                title="Idealsply-product"
                loading="eager"
              />
              <LazyLoad height={200}>
                <img
                  className="hover-img"
                  src={
                    useCloudinary(
                      product.images[1]?.url
                        ? product.images[1]?.url
                        : product.images[0]?.url,
                      "w_500"
                    ) ?? defualtProd
                  }
                  alt="Idealsply-product"
                  title="Idealsply-product"
                  loading="eager"
                />
              </LazyLoad>
            </Link>
          </div>
          <div className="product-action-1">
            <a
              aria-label="Add To Wishlist"
              className="action-btn bg-white"
              onClick={e => handleWishlist(product?._id)}
            >
              {user_favourite?.length >= 1 &&
              user_favourite?.includes(product?._id) ? (
                <FaHeart
                  className="text-danger"
                  style={{ marginTop: "-6px" }}
                />
              ) : (
                <FaRegHeart
                  className="text-black"
                  style={{ marginTop: "-6px" }}
                />
              )}
            </a>
          </div>
        </div>
        <div className="product-content-wrap p-10 pt-0">
          <h2 className="text-size-12 mt-1">
            <Link
              to={`/products/${useRemoveSpace(product?.primaryLang?.name)}`}
            >
              <span>
                {language?.name?.slice(0, 32)} &nbsp;
                <span style={{ whiteSpace: "nowrap" }}>({currentVarient})</span>
              </span>
            </Link>
          </h2>
          <div className="product-price mt-0 p-0">
            {oldPrice && (
              <>
                <span className="old-price font-normal">{oldPrice}</span>
                &nbsp;
              </>
            )}

            <span
              className="font-head text-gray"
              style={{ margin: "0 5px 0 5px" }}
            >
              {currencyCode}
              {price}&nbsp;
            </span>
            {(product?.discountPercentage > 0 || discountPercentage > 0) && (
              <span className="price-per">
                {product?.discountPercentage ?? discountPercentage}% off
              </span>
            )}
          </div>
          {price >= freeShippingThreshold ? (
            <p
              style={{ fontSize: "11px", lineHeight: "11px" }}
              className="pb-0 mb-0 mt-1 text-green  d-flex align-items-center"
            >
              <TbTruckDelivery className="me-1" /> Free Delivery
            </p>
          ) : (
            <p>&nbsp;</p>
          )}
          {stock >= 1 && stock <= 9 ? (
            <p
              style={{ fontSize: "11px", fontWeight: "500" }}
              className="text-warning "
            >
              Only {stock} left
            </p>
          ) : (
            <p>&nbsp;</p>
          )}
        </div>
      </div>
    </>
  )
}

const mapDispatchToProps = {}

export default connect(null, mapDispatchToProps)(ProductCardTwo)

ProductCardTwo.propTypes = {
  product: PropTypes.any,
}
